/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IncidentCategoryControllerListQueryResponse } from "../../models/incidentAgentController/IncidentCategoryControllerList";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { incidentCategoryControllerList } from "../../clients/incident-agentService/incidentCategoryControllerList";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const incidentCategoryControllerListQueryKey = () => [{
  url: '/api/v1/incident-agent/categories'
}] as const;
export type IncidentCategoryControllerListQueryKey = ReturnType<typeof incidentCategoryControllerListQueryKey>;
export function incidentCategoryControllerListQueryOptions(config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = incidentCategoryControllerListQueryKey();
  return queryOptions<IncidentCategoryControllerListQueryResponse, ResponseErrorConfig<Error>, IncidentCategoryControllerListQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return incidentCategoryControllerList(config);
    }
  });
}

/**
 * {@link /api/v1/incident-agent/categories}
 */
export function useIncidentCategoryControllerList<TData = IncidentCategoryControllerListQueryResponse, TQueryData = IncidentCategoryControllerListQueryResponse, TQueryKey extends QueryKey = IncidentCategoryControllerListQueryKey>(options: {
  query?: Partial<QueryObserverOptions<IncidentCategoryControllerListQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? incidentCategoryControllerListQueryKey();
  const query = useQuery({
    ...incidentCategoryControllerListQueryOptions(config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}